<template>
<div class="import-statistics">
    <ab-list-query
        :tabs="tabs"
        @handleTabs="handleTabs"
        >
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4" v-if="activeName == ''">
                    <el-input
                        placeholder="订单编号"
                        v-model.trim="formSearch.customsNumber"
                        clearable
                    ></el-input>
                </el-col>
                <el-col :span="6">
                    <ab-select
                        url="/cms/client/customsAccount/supplierList"
                        inputKey="name"
                        placeholder="请选择供应商"
                        descKey="name"
                        @handleSelect="handleSelect"
                        v-model="formSearch.supplierName"
                        :urlData="{ status: '3' }"
                        >
                        </ab-select>
                </el-col>
                <el-col v-if="activeName == '2'" :span="6">
                    <el-input
                    v-model.trim="formSearch.model"
                    placeholder="型号"
                    clearable
                    ></el-input>
                </el-col>
                <el-col :span="6">
                    <ab-timeSearch
                    class="searchBox"
                    @searchEvent="portDateChange"
                    v-model="portDates"
                    startSrc="报关日期起"
                    endSrc="报关日期止"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm" >搜索</el-button>
                    <el-button link class="btn-svg" @click="resetForm"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>
        
    </ab-list-query>
    <div class="content">
        <order-table v-if="activeName == ''" ref="orderTable" :formSearch="formSearch" :sumData="sumData"></order-table>
        <material-table v-if="activeName == '2'" ref="materialTable" :formSearch="formSearch" :sumData="sumData"></material-table>
    </div>
</div>
</template>

<script>
import orderTable from './import-statistics-order'
import materialTable from './import-statistics-material'
export default {
    name: 'import-statistics',
    components: {
        orderTable,
        materialTable
    },
    data () {
        return {
            tabs: [
                {name: '订单', value: '', state: ''},
                {name: '物料', value: '', state: '2'},
            ],
            formSearch: {},
            activeName: '',
            exportLoading: false,
            isloading: false,
            sumData: {},
            portDates: ''
        }
    },
    created () {
        this.formSearch.portBeginDate = new Date().getFullYear() + '-01' + '-01'
        this.formSearch.portEndDate = this.$utils.formatDate(new Date(), 'yyyy-MM-dd')
        this.portDates = [this.formSearch.portBeginDate, this.formSearch.portEndDate]
    },
    activated () {
        setTimeout(() => {
            this.searchForm()
        }, 50)
    },
    methods: {
        handleTabs (item) {
            this.activeName = item
            this.formSearch.portBeginDate = new Date().getFullYear() + '-01' + '-01'
            this.formSearch.portEndDate = this.$utils.formatDate(new Date(), 'yyyy-MM-dd')
            this.portDates = [this.formSearch.portBeginDate, this.formSearch.portEndDate]
            setTimeout(() => {
                this.getListData()
            }, 50)
        },
        handleSelect (v) {
            if (!v) {
                this.formSearch.supplierId = ''
            } else {
                if (v.id) {
                this.formSearch.supplierId = v.id
                }
            }
            this.searchForm()
        },
        // 报关日期
        portDateChange(val) {
            if (val) {
                this.formSearch.portBeginDate = val[0]
                this.formSearch.portEndDate = val[1]
            } else {
                this.formSearch.portBeginDate = ''
                this.formSearch.portEndDate = ''
            }
            this.searchForm()
        },
        searchForm () {
            this.getListData()
        },
        resetForm () {
            this.formSearch = {}
            this.portDates = []
            this.searchForm()
        },
        getListData () {
            if (this.activeName === '') {
                this.$refs.orderTable.localSearch()
            } else {
                this.$refs.materialTable.localSearch()
            }
            this.getSummaryData()
        },
        getSummaryData() {
            this.$post('/cms/client/customsAccount/summaryData', {
                data: this.formSearch
            }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    data.result.totalUsdAmount = data.result.totalUsdAmount || 0
                    data.result.unPayAmountUsd = data.result.unPayAmountUsd || 0
                    this.sumData = data.result
                } else {
                    this.$message.error(data.message)
                }
            })
        },
    }
}
</script>

<style lang="scss">
.import-statistics {
    .toolbar {
        padding: 0 !important;
    }
    .content {
        margin: 0 20px;
    }
    .list-page{
        padding: 0 !important;
    }
    .list-content {
        padding: 15px 20px 0;
    }
    .table-toolber{
        margin: 0 0 15px !important;
    }
}
</style>